const ar = {
  translation: {
    now: 'الآن',
    apply: 'تطبيق',
    last: 'قبل',
    next: 'بعد',
    years: 'سنوات',
    months: 'شهور',
    weeks: 'أسابيع',
    days: 'أيام',
    hours: 'ساعات',
    minutes: 'دقائق',
    seconds: 'ثوان',
    'month-to-date': 'منذ بداية الشهر حتى الآن',
    'day-to-date': 'منذ بداية اليوم حتى الآن',
    'this-week': 'الأسبوع الحالى',
    'this-month': 'الشهر الحالى',
    'this-year': 'السنة الحالية',
    yesterday: 'أمس',
    'week-to-date': 'منذ بداية الأسبوع حتى الآن',
    'year-to-date': 'منذ بداية السنة حتى الآن',
    'years-ago': 'سنوات سابقة',
    'months-ago': 'شهور سابقة',
    'weeks-ago': 'أسابيع سابقة',
    'days-ago': 'أيام سابقة',
    'hours-ago': 'ساعات سابقة',
    'minutes-ago': 'دقائق سابقة',
    'seconds-ago': 'ثوان سابقة',
    'years-from-now': 'سنوات قادمة',
    'months-from-now': 'شهور قادمة',
    'weeks-from-now': 'أسابيع قادمة',
    'days-from-now': 'أيام قادمة',
    'hours-from-now': 'ساعات قادمة',
    'minutes-from-now': 'دقائق قادمة',
    'seconds-from-now': 'ثوان قادمة',
    absolute: 'محدد',
    relative: 'نسبى',
    mainPage: 'الصفحة الرئيسية',
    'requests-count-stats': 'إحصائيات عدد الطلبات',
    'requests-status-stats': 'إحصائيات حالة الطلبات',
    'user-stats': 'إحصائيات المستخدمين',
    'payments-stats': 'إحصائيات المدفوعات',
    'emergency-app-stats': ' إحصائيات تطبيق الطوارئ',
    'performance-indicators-stats': 'إحصائيات مؤشرات الأداء',
    'platform-response-indicators': 'مؤشرات إستجابة المنصة',
    'cid-stats': ' إحصائيات الـ CID',
    'rating-stats': 'إحصائيات التقييمات',
    signout: 'تسجيل خروج',
    version: 'رقم الإصدار',
    copyRights: 'جميع الحقوق محفوظة ©',
    login: 'تسجيل دخول',
    'login-error-retry': 'إعادة محاولة تسجيل الدخول',
    appTitle: 'منصة إحصائيات خدمات الكهرباء',
    AUTHORIZATION_REQUIRED: 'لا تملك صلاحية',
    error: 'حدث خطأ',
    'error-extend': 'حدث خطأ أثناء محاولة العثور على البيانات',
    retry: 'إعادة المحاولة',
    home: 'الرئيسية',
    search: 'بحث',
    invalid: 'غير صحيح',
    required: 'مطلوب',
    sum: 'الإجمالى',
    perc: 'النسبة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    start: 'البداية',
    end: 'النهاية',
  },
};

export default ar;
